/* Generic Shopify search support. Matching and ranking belong to Shopify. */
(function () {
  'use strict';
  if (window.StorefrontSearch) return;
  var config = window.storefrontSearchConfig || {};
  var ROOT_URL = String(config.rootUrl || '/').replace(/\/+$/, '');

  function normalize(query) {
    return String(query || '').replace(/[۰-۹]/g, function (digit) {
      return String(digit.charCodeAt(0) - 1776);
    }).replace(/[٠-٩]/g, function (digit) {
      return String(digit.charCodeAt(0) - 1632);
    }).replace(/\s+/g, ' ').trim();
  }

  function localizedPath(path) {
    return ROOT_URL + '/' + String(path || '').replace(/^\/+/, '');
  }

  function searchUrl(query) {
    var params = new URLSearchParams({ q: normalize(query), type: 'product', 'options[prefix]': 'last' });
    return localizedPath('/search') + '?' + params.toString();
  }

  function predictiveUrl(query) {
    var route = (window.routes && window.routes.predictive_search_url) || localizedPath('/search/suggest');
    var params = new URLSearchParams({
      q: normalize(query), section_id: 'predictive-search',
      'resources[limit]': '10', 'resources[limit_scope]': 'all',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku'
    });
    return route + '?' + params.toString();
  }

  function predictiveSupported() {
    try {
      var features = document.getElementById('shopify-features');
      return !features || JSON.parse(features.textContent).predictiveSearch !== false;
    } catch (error) { return true; }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function addLinks(host, title, values, className) {
    if (!values || !values.length) return;
    var group = el('div', 'sr__group ' + (className || ''));
    group.appendChild(el('div', 'sr__label', title));
    var links = el('div', 'sr__links');
    values.forEach(function (value) {
      var item = typeof value === 'string' ? { label: value, query: value } : value;
      var link = el('a', 'sr__chip', item.label);
      link.href = item.href || searchUrl(item.query || item.label);
      links.appendChild(link);
    });
    group.appendChild(links);
    host.appendChild(group);
  }

  function recentlyViewed() {
    try {
      var history = JSON.parse(localStorage.getItem('alasil:recently-viewed:v1') || '[]');
      if (!Array.isArray(history)) return [];
      return history.slice(0, 5).map(function (entry) {
        var handle = typeof entry === 'string' ? entry : entry && entry.handle;
        if (!handle || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return null;
        var label = handle.replace(/-/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
        return { label: label, href: localizedPath('/products/' + encodeURIComponent(handle)) };
      }).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function countProducts(container) {
    if (!container) return 0;
    return container.querySelectorAll(
      '[id*="predictive-search-option-product"], .search_result-products .predictive-search__list-item, #product-grid .product-grid > li'
    ).length;
  }


  function enhance(container, query, options) {
    if (!container || !query) return;
    var old = container.querySelector(':scope > .search-recovery');
    if (old) old.remove();
    if (options && options.productCount > 0) return;
    var panel = el('section', 'search-recovery search-recovery--weak');
    panel.setAttribute('aria-label', config.panelLabel || 'Search help');
    panel.appendChild(el('h2', 'sr__title', config.needHelp || 'Need help finding the right product?'));
    addLinks(panel, config.popular || 'Suggested searches', config.popularTerms || [], 'sr__group--popular');
    addLinks(panel, config.recent || 'Recently viewed', recentlyViewed(), 'sr__group--recent');
    if (config.whatsapp) {
      var finder = el('a', 'sr__whatsapp', config.whatsappCta || 'Get help finding a product');
      finder.href = 'https://wa.me/' + String(config.whatsapp).replace(/\D/g, '') + '?text=' + encodeURIComponent(
        (config.whatsappMessage || 'Help me find this product: __QUERY__').replace('__QUERY__', query)
      );
      finder.target = '_blank';
      finder.rel = 'noopener';
      panel.appendChild(finder);
    }
    container.insertBefore(panel, container.firstChild);
  }

  function migrateLegacySearch() {
    if (!document.querySelector('.template-search')) return false;
    var params = new URLSearchParams(window.location.search);
    if (!params.has('recovery_from')) return false;
    params.set('q', normalize(params.get('recovery_from')));
    // These filters were inferred by the retired helper, not selected by a buyer.
    ['filter.p.product_type', 'filter.p.m.custom.ram', 'filter.p.m.custom.storage_capacity',
      'recovery_from', 'recovery_level', 'recovery_nearest', 'search_exact', 'page'].forEach(function (key) {
      params.delete(key);
    });
    window.location.replace(window.location.pathname + '?' + params.toString());
    return true;
  }

  function enhanceSearchPage() {
    var page = document.querySelector('.template-search');
    if (!page || migrateLegacySearch()) return;
    var query = new URLSearchParams(window.location.search).get('q') || '';
    if (!query) return;
    document.querySelectorAll('.mobile-search-trigger').forEach(function (trigger) {
      var label = trigger.querySelector('.mobile-search-trigger__placeholder');
      if (label) label.textContent = query;
      trigger.setAttribute('aria-label', query);
    });
    var sheet = document.getElementById('SearchSheet');
    if (sheet) sheet.dataset.initialQuery = query;
    enhance(page.querySelector('.template-search__header'), query, { productCount: countProducts(page) });
  }

  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[role="search"], form[action*="/search"]')) return;
    var input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;
    event.formData.set('q', normalize(input.value));
  }, true);

  window.StorefrontSearch = {
    normalize: normalize, searchUrl: searchUrl, predictiveUrl: predictiveUrl,
    predictiveSupported: predictiveSupported, enhance: enhance, countProducts: countProducts
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSearchPage, { once: true });
  } else { enhanceSearchPage(); }
  document.addEventListener('facets:grid-updated', enhanceSearchPage);
})();
